import { useEnqueteAnswerInputApi } from 'src/api/useEnqueteAnswerInputApi';
import { useAppDispatch } from 'src/redux/store';
import { EnqueteAnswerEntity, setConfirmHistoryData, setConfirmRequestData, setEnqueteAnswerAction5Data, setEnqueteAnswerData } from '../store/enqueteAnswerSlice';

const useEnqueteAnswer = () => {
  const dispatch = useAppDispatch();
  const { getAnswer, getConfirmRequest, getConfirmHistoryData, getAnswerAction5 } = useEnqueteAnswerInputApi();
  const fetchAnswer = async (respondentTargetId: string): Promise<EnqueteAnswerEntity | undefined> => {
    try {
      const response = await getAnswer(respondentTargetId);
      if (response) dispatch(setEnqueteAnswerData(response ?? {}));
      return response;
    } catch (error: unknown) {
      throw error;
    }
  };

  const fetchConfirmRequest = async (confrimRequestId: string): Promise<void> => {
    try {
      const response = await getConfirmRequest(confrimRequestId);
      if (response) dispatch(setConfirmRequestData(response));
    } catch (error: unknown) {
      throw error;
    }
  };

  const fetchConfirmHistories = async (answerId: string): Promise<void> => {
    try {
      const response = await getConfirmHistoryData(answerId);
      dispatch(setConfirmHistoryData(response));
    } catch (error: unknown) {
      throw error;
    }
  };

  //アクション⑤回答取得
  const fetchAnswerAction5 = async (respondentTargetId: string): Promise<EnqueteAnswerEntity | undefined> => {
    try {
      //データ取得
      const response = await getAnswerAction5(respondentTargetId);
      //データ設定
      if (response) dispatch(setEnqueteAnswerAction5Data(response ?? {}));
      return response;
    } catch (error: unknown) {
      //エラーをキャッチする
      throw error;
    }
  };

  return {
    fetchAnswer,
    fetchConfirmRequest,
    fetchConfirmHistories,
    fetchAnswerAction5,
  };
};

export default useEnqueteAnswer;
